export default __webpack_public_path__ + "scene1_4_bg3c088f.png";